import { render } from "./DbAccessTable.vue?vue&type=template&id=52c3f93e"
import script from "./DbAccessTable.vue?vue&type=script&lang=js"
export * from "./DbAccessTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__